import Keycloak, { KeycloakConfig } from 'keycloak-js';

const keycloakConfig: KeycloakConfig = {
  url: process.env.REACT_APP_KC_HOST || 'http://localhost:8080',
  realm: process.env.REACT_APP_KC_REALM || 'myrealm',
  clientId: process.env.REACT_APP_KC_CLIENT_ID || 'myclient',
};

class KeycloakInstance {
  private static instance: Keycloak | null = null;

  public static getInstance(): Keycloak {
    if (!KeycloakInstance.instance) {
      KeycloakInstance.instance = new Keycloak(keycloakConfig);
    }
    return KeycloakInstance.instance;
  }
}

export default KeycloakInstance.getInstance();
